import useSWR from 'swr';
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

export function useSettings() {
  const { data: settings, isLoading } = useSWR('general_settings', async () => {
    try {
      const snap = await getDoc(doc(db, 'settings', 'general'));
      if (snap.exists()) {
        return snap.data();
      }
    } catch (err) {
      console.warn("Failed to fetch general settings from Firestore. Falling back to default empty object.", err);
    }
    return {};
  });

  return { settings: settings || {}, loading: isLoading };
}
